import { render, staticRenderFns } from "./Consulta.vue?vue&type=template&id=aa81fbc0&"
import script from "./Consulta.vue?vue&type=script&lang=js&"
export * from "./Consulta.vue?vue&type=script&lang=js&"
import style0 from "./Consulta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports